import { render, staticRenderFns } from "./tutorPopup.vue?vue&type=template&id=76de2d12"
import script from "./tutorPopup.vue?vue&type=script&lang=js"
export * from "./tutorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports